import React from 'react';
import OrderDetailUI from "../../components/admin/purchase_order/components/OrderDetail";
import PersistentDrawerLeft from "../../components/reusable/admin/Main";
const PurchaseOrderDetail = () => {
  return (
    <div>
      <PersistentDrawerLeft>
      <OrderDetailUI />
      </PersistentDrawerLeft>
    </div>
  );
};

export default PurchaseOrderDetail;